import type { DataContainer } from '@otto-ec/tracking-bct';
import type { IntentMeta, ProductType } from '@shared/types/types';

export type EventMergeId = string;

type LabelScalar = string | number | boolean;
type LabelValue = LabelScalar | ReadonlyArray<LabelScalar>;

export type PrimitiveLabels = Record<string, LabelValue>;

export type ApiTrackingLabels = NonNullable<IntentMeta['tracking']>;

export type KnownTrackingLabels = Partial<{
    san_Comparison: boolean;
    san_ComparisonActivity:
        | 'toggle_on'
        | 'toggle_off'
        | 'selected'
        | 'deselected'
        | 'deselected_all'
        | 'start'
        | 'sheet_open'
        | 'sheet_close';
    san_HeaderType: 'mobile';
    san_Interaction:
        | 'browser_navigation'
        | 'brand_tile'
        | 'ranking_info_open'
        | 'ranking_info_close'
        | 'paging_bottom'
        | 'product_color_change'
        | 'product_image_change'
        | 'datasheet_list'
        | 'datasheet_layer'
        | 'link_to_list'
        | `${ProductType}_product_tile`;
    san_ListEventType: 'tilelistview';
    san_ListLayer: 'energyclass' | 'sponsored product' | 'rating';
    san_ReptileExperimentFlexLabel: string;
    san_OrganicListPosition: number;
    san_ProductColorCount: number;
    san_ProductType: ProductType | 'brand';

    'wk.san_CountPages': number;
    'wk.san_ListFeedbackTool': 'feedback_ltr';
    'wk.san_ListOrder': string;
    'wk.san_ListPosition': number;
    'wk.san_ListPositionSimilar': number;
    'wk.san_OrganicListPosition': number;
    'wk.san_PageNumber': number;
    'wk.san_ProductClickListType': string;
    'wk.san_ProductLinkType': string;
    'wk.san_ProductType': ProductType | 'brand';
    'wk.san_ReptileExperimentSegment': string[];
    'wk.san_TopInfoList': boolean;
    'wk.san_EntrySelectionRule': string;
    'wk.san_SelectionRule': string;

    ot_PageCluster: string;
    ot_VisibleUrl: string;
}>;

export type TrackingLabels = PrimitiveLabels & KnownTrackingLabels;

export function convertLabelsToDataContainer(labels: PrimitiveLabels): DataContainer {
    const dataContainer: DataContainer = {};

    Object.entries(labels).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            return;
        }

        dataContainer[key] = (Array.isArray(value) ? value : [value]).map(String);
    });

    return dataContainer;
}
